module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0003_004.8f4f0ae7.png";